export default "__VITE_ASSET__BZyQbS$I__"